import { Injectable } from '@angular/core';
import { ShipmentStatus } from '../enums';
import { Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';

@Injectable({
  providedIn: 'root',
})
export class ShipmentStatusProviderService {
  private readonly entries = new Map<ShipmentStatus, string>([
    [ShipmentStatus.Cancelled, 'Anulowana'],
    [ShipmentStatus.Deleted, 'Usunięta'],
    [ShipmentStatus.Pending, 'W trakcie'],
    [ShipmentStatus.Sent, 'Wysłana'],
  ]);

  public labelFor(status: ShipmentStatus): Observable<string> {
    return of(this.entries.get(status) || 'Nieznany');
  }

  public selectItems(): Observable<SelectItem<ShipmentStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem<ShipmentStatus>(label, type),
      ),
    );
  }
}
